import { useAemConfig } from '@as-react/common-components';
import { getHomepageUrl } from '@as-react/common-utils';
import { useIsClient } from '@yonderland/andes-react';
import { useEffect } from 'react';
import { findParents } from '../../../../util/HtmlElementUtil';
/**
 * @deprecated
 */
export const CategoryHierarchyTreeMobileHelper = ({ categoryIds, hierarchyTree }) => {
    const { lang } = useAemConfig();
    const isClient = useIsClient();
    const walkCategoryHierarchyTree = (hierchyTreeItem) => {
        var _a;
        // If Item has children, proceed down the tree, else search for a link in the menu and select its parent menu items.
        if (hierchyTreeItem.children && ((_a = hierchyTreeItem.children) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            hierchyTreeItem.children.map(hierchyTreeItemChild => walkCategoryHierarchyTree(hierchyTreeItemChild));
            return;
        }
        const isActive = categoryIds.includes(hierchyTreeItem.item.categoryId);
        if (!isActive)
            return;
        const link = getHomepageUrl(hierchyTreeItem.item.categoryTranslatedProperties[lang.toLocaleUpperCase()].link);
        // Check corresponding mobile menu item
        const query = `.as-a-menu-item .as-a-link[href*="${link}"]`;
        const menuItem = document.querySelector(query);
        if (!menuItem)
            return;
        const menuItemCheckbox = menuItem.previousElementSibling;
        if (!menuItemCheckbox) {
            menuItem.classList.add('as-a-menu-item--mobile-only-active');
        }
        const parentMenuWrappers = findParents(menuItem, '[data-js-menu-has-flyout]');
        parentMenuWrappers.forEach(menuWrapper => {
            const menuWrapperCheckbox = menuWrapper.querySelector(':scope > input');
            if (menuWrapperCheckbox) {
                // use setAttribute so reset (on flyout close) will reset to the category menu by default.
                menuWrapperCheckbox.setAttribute('checked', 'checked');
            }
        });
    };
    useEffect(() => {
        if (!isClient) {
            return;
        }
        walkCategoryHierarchyTree(hierarchyTree);
    }, [hierarchyTree, isClient]);
    return null;
};
